'use client'

import { ErrorDataUnavailable } from '@/components/common/Error'

import { HeaderOracles } from '../OraclesMarket'

export default function OraclesMarketEmpty() {
  return (
    <div className="gap-2xs flex w-full flex-col" data-testid="oracles-market-empty">
      <HeaderOracles />
      <ErrorDataUnavailable
        minHeight="132px"
        title="No oracle data yet"
        description="This market uses an asset Morpho does not list yet."
        showActions={false}
      />
    </div>
  )
}
